import { Builder } from "@builder.io/react";

import { CostCalculatorForm } from "@/modules/cost-calculator/calculator-form";

import { interactiveElementsComponentsNames } from "../consts";

export function CostCalculator() {
  return <CostCalculatorForm />;
}

Builder.registerComponent(CostCalculator, {
  name: interactiveElementsComponentsNames.COST_CALCULATOR,
});
